import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Taxis.css';
import { taxis } from '../../data/taxis';

const Taxis = () => {
  // Contact form state
  const [formData, setFormData] = useState({ name: '', phone: '', email: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setAgreedToTerms(checked);
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreedToTerms) {
      setErrorMessage('יש לאשר את תנאי השימוש ומדיניות הפרטיות.');
      return;
    }

    setIsSubmitting(true);
    setSuccessMessage('');
    setErrorMessage('');
    try {
      const response = await fetch('https://hook.eu2.make.com/2t459gwcwzl5ywtmjunkpke62g4hspg1', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, timestamp: new Date().toISOString(), source: 'taxis-page' })
      });
      if (response.ok) {
        setSuccessMessage('תודה! פרטיך נשלחו בהצלחה.');
        setFormData({ name: '', phone: '', email: '' });
      } else {
        setErrorMessage('אירעה שגיאה בשליחת הטופס.');
      }
    } catch {
      setErrorMessage('אירעה שגיאה בשליחת הטופס.');
    }
    setIsSubmitting(false);
  };

  return (
    <div className="taxis-page">
      {/* Section 1: Header and Explanation */}
      <section className="taxis-hero">
        <div className="container">
          <h1>✨ התמחות במוניות – ניסיון של שנים</h1>
          <p>
            אנחנו מתמחים בייבוא, מכירה והתאמה אישית של מוניות. מהיבואנים הגדולים בארץ עם ניסיון של שנים ואלפי לקוחות מרוצים.
          </p>
        </div>
      </section>

      {/* Section 2: Car Catalog */}
      <section className="taxis-catalog">
        <div className="container">
          <h2>קטלוג רכבים</h2>
          <div className="taxis-grid">
            {taxis.map((taxi) => (
              <div key={taxi.id} className="taxi-card">
                <div className="taxi-image">
                  <img src={taxi.image} alt={taxi.model} />
                </div>
                <div className="taxi-content">
                  <h3>{taxi.model}</h3>
                  <p className="taxi-price">₪{taxi.price.toLocaleString()} כולל מע"מ</p>
                  <Link to={`/cars/${taxi.slug}`} className="taxi-link">
                    לפרטים נוספים
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 3: Location Map */}
      <section className="taxis-location">
        <div className="container">
          <h2>מפת מיקום</h2>
          <div className="location-address">
            <i className="fas fa-map-marker-alt"></i>
            <span>כתובת: התמר 3, אבן יהודה</span>
          </div>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=התמר+3+אבן+יהודה,+ישראל&zoom=16"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="taxis-contact-form">
        <div className="container">
          <h3 className="contact-form-header">צרו איתנו קשר - עוד היום</h3>
          <form className="horizontal-contact-form" onSubmit={handleSubmit}>
            {/* Container for input fields and button */}
            <div className="form-inputs-button">
              <input
                type="text"
                name="name"
                placeholder="שם מלא"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
              <input
                type="tel"
                name="phone"
                placeholder="טלפון"
                value={formData.phone}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
              <input
                type="email"
                name="email"
                placeholder="אימייל"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
              <button type="submit" disabled={isSubmitting} className="black-yellow-btn">
                {isSubmitting ? 'שולח...' : 'שלח' }
              </button>
            </div>

            {/* Terms and Conditions Checkbox */}
            <div className="form-group terms-checkbox full-width">
            <label htmlFor="terms-taxis">
                אני מאשר/ת את <a href="/terms" target="_blank" rel="noopener noreferrer">תנאי השימוש ומדיניות הפרטיות</a> ומסכים/ה לשמירת פרטיי ויצירת קשר.
              </label>
              <input 
                type="checkbox" 
                id="terms-taxis"
                name="terms"
                checked={agreedToTerms}
                onChange={handleChange}
                required 
                disabled={isSubmitting}
              />
             
            </div>
          </form>
          {successMessage && <div className="success-message">{successMessage}</div>}
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      </section>
    </div>
  );
};

export default Taxis; 